var map = {
	"./cardhub-logo.svg": 46,
	"./defaultProfileAvatar.svg": 34,
	"./flagBrasil.svg": 55,
	"./flagEngland.svg": 56,
	"./flagFiambres.svg": 58,
	"./flagSpain.svg": 57,
	"./isoLogo-dark.svg": 150,
	"./isoLogo-light.svg": 151,
	"./mailbox-dark.svg": 152,
	"./mailbox-light.svg": 153,
	"./stamp-dark.svg": 154,
	"./stamp-light.svg": 155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 149;